export const translation = {
  lblUcsaa: "lblUcsaa",
  lblDelinkAccount: "lblDelinkAccount",
  English: "English",
  Hindi: "Hindi",
  Marathi: "Marathi",
  lblAAProfile: "lblAAProfile",
  No: "No",
  From: "From",
  to: "to",
  Done: "Done",
  Created: "Created",
  Updated: "Updated",
  lblConsentApproved: "lblConsentApproved",
  lblConsentRejected: "lblConsentRejected",
  lblLoginSuccess: "lblLoginSuccess",
  lblLogoutSuccess: "lblLogoutSuccess",
  lblAccountLinkSuccess: "lblAccountLinkSuccess",
  lblSingupSuccess: "lblSingupSuccess",
  lblConsentStatusChange: "lblConsentStatusChange",
  AA_FIP_ACCOUNT_DISCOVERY: "AA_FIP_ACCOUNT_DISCOVERY",
  AA_FIP_ACCOUNT_LINKING: "AA_FIP_ACCOUNT_LINKING",
  AA_UPDATE_CONSENT_STATUS: "AA_UPDATE_CONSENT_STATUS",
  AA_UPDATE_CONSENT_STATUS_ACCOUNT: "AA_UPDATE_CONSENT_STATUS_ACCOUNT",
  AA_STORE_CREATE_CONSENT_REQUEST: "AA_STORE_CREATE_CONSENT_REQUEST",
  account: "account",
  success: "success",
  lblNoRecentActivities: "lblNoRecentActivities",
  lblApprove: "lblApprove",
  PIN: "PIN",
  OTP: "OTP",
  PAUSED: "PAUSED",
  REJECTED: "REJECTED",
  REVOKED: "REVOKED",
  EXPIRED: "EXPIRED",
  lblCollapseSidebar: "lblCollapseSidebar",
  Accounts: "Accounts",
  Consents: "Consents",
  lblUserActivity: "lblUserActivity",
  Logout: "Logout",
  Support: "Support",
  lblDeleteUser: "lblDeleteUser",
  Settings: "Settings",
  lblAccountsLinkedTypo: "lblAccountsLinkedTypo",
  lblAddNewIdentifier: "lblAddNewIdentifier",
  accounts: "accounts",
  change: "change",
  lblMobileLinked: "lblMobileLinked",
  ACCOUNT_DELINK: "ACCOUNT_DELINK",
  Profile: "Profile",
  Update: "Update",
  lblUpdatePin: "lblUpdatePin",
  lblResetPin: "lblResetPin",
  lblMobileNumbers: "lblMobileNumbers",
  lblPrimaryMobileNumbers: "lblPrimaryMobileNumbers",
  lblPrimaryMobileNumbersDesc: "lblPrimaryMobileNumbersDesc",
  lblSecondaryMobileNumbers: "lblSecondaryMobileNumbers",
  lblSecondaryMobileNumbersDesc: "lblSecondaryMobileNumbersDesc",
  lblStrongIdentifiers: "lblStrongIdentifiers",
  lblStrongIdentifiersDesc: "lblStrongIdentifiersDesc",
  lblOtherIdentifiers: "lblOtherIdentifiers",
  lblOtherIdentifiersDesc: "lblOtherIdentifiersDesc",
  lblPinUpdateSuccess: "lblPinUpdateSuccess",
  lblPinMatchError: "lblPinMatchError",
  lblResetPinError: "lblResetPinError",
  AA_STORE_SAVE_FI_REQUEST: "AA_STORE_SAVE_FI_REQUEST",
  lblIssuesFound: "lblIssuesFound",
  lblInformatioFetch: "lblInformatioFetch",
  lblTimes: "lblTimes",
  lblFIUInformationStore: "lblFIUInformationStore",
  FIType: "FIType",
  lblViewLogs: "lblViewLogs",
  lblAddIdentifier: "lblAddIdentifier",
  Identifiers: "Identifiers",
  lblIdentifierSelectionError: "lblIdentifierSelectionError",
  AA_STORE_SAVE_FI_REQUEST_ACCOUNT: "AA_STORE_SAVE_FI_REQUEST_ACCOUNT",
  lblConsentType: "lblConsentType",
  lblFiDataPullFrequency: "lblFiDataPullFrequency",
  lblOnlyOnce: "lblOnlyOnce",
  PURPOSE: "PURPOSE",
  lblConsumerId: "lblConsumerId",
  lblConsentMode: "lblConsentMode",
  lblDataFilters: "lblDataFilters",
  lblFiDataRange: "lblFiDataRange",
  lblFiDataLife: "lblFiDataLife",
  errorInvalidPhoneNumber: "errorInvalidPhoneNumber",
  errorInvalidPin: "errorInvalidPin",
  errorRequiredPhoneNumber: "errorRequiredPhoneNumber",
  errorRequiredvalue: "errorRequiredvalue",
  errorInvalidDateFormat: "errorInvalidDateFormat",
  errorInvalidDate: "errorInvalidDate",
  lblResend: "lblResend",
  lblEnterOTP: "lblEnterOTP",
  lblCodeSendTo: "lblCodeSendTo",
  lblOk: "lblOk",
  lblCancel: "lblCancel",
  lblNext: "lblNext",
  internetNotConnected: "internetNotConnected",
  lblLogout: "lblLogout",
  lblLogin: "lblLogin",
  lblLoginTo: "lblLoginTo",
  msgLogin: "msgLogin",
  lblGetStarted: "lblGetStarted",
  msgLogout: "msgLogout",
  msgDetailsLogout: "msgDetailsLogout",
  lblSessionTimedOut: "lblSessionTimedOut",
  lblEnglish: "lblEnglish",
  lblHindi: "lblHindi",
  lblContinue: "lblContinue",
  lblSelectLanguage: "lblSelectLanguage",
  lblDontHaveAccount: "lblDontHaveAccount",
  lblAlreadyHaveAccount: "lblAlreadyHaveAccount",
  lblCreateAccount: "lblCreateAccount",
  lblFirstBoardingFirst: "lblFirstBoardingFirst",
  lblCreateAccountTo: "lblCreateAccountTo",
  msgRegistration: "msgRegistration",
  lblFirstBoardingSecond: "lblFirstBoardingSecond",
  lblSecondBoardingFirst: "lblSecondBoardingFirst",
  lblSecondBoardingSecond: "lblSecondBoardingSecond",
  lblThirdBoardingFirst: "lblThirdBoardingFirst",
  lblThirdBoardingSecond: "lblThirdBoardingSecond",
  lblEnterAAHandle: "lblEnterAAHandle",
  errorEnterAAHandle: "errorEnterAAHandle",
  errofCustomValidation: "errofCustomValidation",
  lblEnterPin: "lblEnterPin",
  lblCreatePassCode: "lblCreatePassCode",
  lblConfirmPassCode: "lblConfirmPassCode",
  lblSetPin: "lblSetPin",
  errorEnterPin: "errorEnterPin",
  errorPinLength: "errorPinLength",
  lblForgotPassword: "lblForgotPassword",
  errorEnterValidOTP: "errorEnterValidOTP",
  lblWelcome: "lblWelcome",
  lblSubWelcome: "lblSubWelcome",
  lblMobileNumber: "lblMobileNumber",
  lblAddNew: "lblAddNew",
  lblAdd: "lblAdd",
  errorMobileNumber: "errorMobileNumber",
  lblAgreeTerms: "lblAgreeTerms",
  errorNoBanksFound: "errorNoBanksFound",
  errorNoIdentifiersFound: "errorNoIdentifiersFound",
  errorNoAccountsFound: "errorNoAccountsFound",
  errorNoDetailsFound: "errorNoDetailsFound",
  errorSomeThingWentWrong: "errorSomeThingWentWrong",
  lblSuccessfullyCreatedAccount: "lblSuccessfullyCreatedAccount",
  lblHomeSearch: "lblHomeSearch",
  lblSearchByMobile: "lblSearchByMobile",
  lblAccountSearch: "lblAccountSearch",
  lblLinkAccounts: "lblLinkAccounts",
  lblLinkBankAccounts: "lblLinkBankAccounts",
  lblLinkAccount: "lblLinkAccount",
  lblLinkedAccounts: "lblLinkedAccounts",
  lblNoLinkedAccounts: "lblNoLinkedAccounts",
  lblNoActiveConsent: "lblNoActiveConsent",
  lblNoPendingConsent: "lblNoPendingConsent",
  lblNoPausedConsent: "lblNoPausedConsent",
  lblNoOtherConsent: "lblNoOtherConsent",
  lblUnLinkAccounts: "lblUnLinkAccounts",
  msgUnLinkAccounts: "msgUnLinkAccounts",
  msgSubTitleUnLinkAccounts: "msgSubTitleUnLinkAccounts",
  lblNewConsent: "lblNewConsent",
  lblActiveConsent: "lblActiveConsent",
  lblReactivateConsent: "lblReactivateConsent",
  lblPendingConsent: "lblPendingConsent",
  lblAllConsent: "lblAllConsent",
  lblRejectedConsent: "lblRejectedConsent",
  lblExpiredConsent: "lblExpiredConsent",
  lblOtherConsent: "lblOtherConsent",
  lblPastConsent: "lblPastConsent",
  msgLinkedAccounts: "msgLinkedAccounts",
  lblReject: "lblReject",
  lblRevoke: "lblRevoke",
  lblPause: "lblPause",
  lblPauseConsent: "lblPauseConsent",
  lblPausedConsent: "lblPausedConsent",
  msgReject: "msgReject",
  lblConfirm: "lblConfirm",
  lblIAgreeTo: "lblIAgreeTo",
  lblLetsGetStarted: "lblLetsGetStarted",
  lblTermsAndConditions: "lblTermsAndConditions",
  lblPrivacyAndPolicy: "lblPrivacyAndPolicy",
  lblGrievanceRedressal: "lblGrievanceRedressal",
  lblAboutUs: "lblAboutUs",
  lblChangeLanguage: "lblChangeLanguage",
  lblChangeTheme: "lblChangeTheme",
  lblViewDetails: "lblViewDetails",
  lblAccept: "lblAccept",
  msgAccept: "msgAccept",
  lblSkip: "lblSkip",
  lblAcceptConsent: "lblAcceptConsent",
  lblRejectConsent: "lblRejectConsent",
  lblRevokeConsent: "lblRevokeConsent",
  lblRevokedConsent: "lblRevokedConsent",
  lblAccountDetails: "lblAccountDetails",
  msgAchieveFinanceGoals: "msgAchieveFinanceGoals",
  lblDataSuccessfullyFetched: "lblDataSuccessfullyFetched",
  lblGoodMorning: "lblGoodMorning",
  lblGoodAfterNoon: "lblGoodAfterNoon",
  lblGoodEvening: "lblGoodEvening",
  lblGoodDay: "lblGoodDay",
  lblHello: "lblHello",
  lblSelectAccountForSharingInfo: "lblSelectAccountForSharingInfo",
  lblAccountPermissionAndInfoAccess: "lblAccountPermissionAndInfoAccess",
  lblWantsToAccessAccount: "lblWantsToAccessAccount",
  lblCanAccessAccount: "lblCanAccessAccount",
  lblCanNotAccessAccount: "lblCanNotAccessAccount",
  errorSendingOTP: "errorSendingOTP",
  lblOTPSendSuccess: "lblOTPSendSuccess",
  lblOTPSVerifiedSuccess: "lblOTPSVerifiedSuccess",
  lblAccountRevokeSuccess: "lblAccountRevokeSuccess",
  lblAccountPauseSuccess: "lblAccountPauseSuccess",
  lblAccountUnLinkedSuccess: "lblAccountUnLinkedSuccess",
  lblOTPVerificationFailure: "lblOTPVerificationFailure",
  lblPinVerificationFailure: "lblPinVerificationFailure",
  lblSelectMethodForVerification: "lblSelectMethodForVerification",
  errorConsentNotFound: "errorConsentNotFound",
  lblForgotPin: "lblForgotPin",
  msgForgotPin: "msgForgotPin",
  lblSendOTP: "lblSendOTP",
  lblSubmit: "lblSubmit",
  msgPinResetSuccess: "msgPinResetSuccess",
  msgConfirmResetPin: "msgConfirmResetPin",
  msgPressBackToExit: "msgPressBackToExit",
  lblLoginWithPin: "lblLoginWithPin",
  lblLoginWithOTP: "lblLoginWithOTP",
  lblFirstName: "lblFirstName",
  lblLastName: "lblLastName",
  lblEmail: "lblEmail",
  errorRequiredFirstName: "errorRequiredFirstName",
  errorRequiredLastName: "errorRequiredLastName",
  lblAnalytics: "lblAnalytics",
  lblHistory: "lblHistory",
  lblFrequentlyAsked: "lblFrequentlyAsked",
  lblHelpCenter: "lblHelpCenter",
  lblSettings: "lblSettings",
  lblGeneral: "lblGeneral",
  lblConsent: "lblConsent",
  lblCreateNewTicket: "lblCreateNewTicket",
  lblTitle: "lblTitle",
  lblMessage: "lblMessage",
  lblAccounts: "lblAccounts",
  lblOppositeLanguage: "lblOppositeLanguage",
  lblCurrentLanguage: "lblCurrentLanguage",
  lblAuditDiscoverAccounts: "lblAuditDiscoverAccounts",
  lblAuditAccountLinkWith: "lblAuditAccountLinkWith",
  lblAuditStoreAccountLink: "lblAuditStoreAccountLink",
  lblAuditInitiateAccountLinkVerificationProcess:
    "lblAuditInitiateAccountLinkVerificationProcess",
  lblAuditLinkAccount: "lblAuditLinkAccount",
  lblAuditUnLinkAccount: "lblAuditUnLinkAccount",
  lblAuditStoreSaveFiRequest: "lblAuditStoreSaveFiRequest",
  lblAuditCreateConsent: "lblAuditCreateConsent",
  lblAuditVerifyConsent: "lblAuditVerifyConsent",
  lblAuditStoreUpdateConsentRequestFirst:
    "lblAuditStoreUpdateConsentRequestFirst",
  lblAuditStoreUpdateConsentRequestSecond:
    "lblAuditStoreUpdateConsentRequestSecond",
  lblAuditIPFiFetch: "lblAuditIPFiFetch",
  lblAuditStoreConsentAccountFirst: "lblAuditStoreConsentAccountFirst",
  lblAuditStoreConsentAccountSecond: "lblAuditStoreConsentAccountSecond",
  lblPeriodic: "lblPeriodic",
  lblConsentExpiry: "lblConsentExpiry",
  lblProfileSummaryTransaction: "lblProfileSummaryTransaction",
  lblPurpose: "lblPurpose",
  msgLinkNewMobileNumberAsIdentifier: "msgLinkNewMobileNumberAsIdentifier",
  lblDiscoverAccounts: "lblDiscoverAccounts",
  lblIdentifiersFirst: "lblIdentifiersFirst",
  lblIdentifiersSecond: "lblIdentifiersSecond",
  lblResume: "lblResume",
  lblResumeConsent: "lblResumeConsent",
  errorRetryAgain: "errorRetryAgain",
  lblUserProfile: "lblUserProfile",
  lblUpdateProfile: "lblUpdateProfile",
  lblHandle: "lblHandle",
  msgUserProfileSuccess: "msgUserProfileSuccess",
  lblOldPin: "lblOldPin",
  lblNewPin: "lblNewPin",
  lblConfirmPin: "lblConfirmPin",
  lblVerifyIdentity: "lblVerifyIdentity",
  errorOldPinRequired: "errorOldPinRequired",
  errorNewPinRequired: "errorNewPinRequired",
  errorConfirmPinRequired: "errorConfirmPinRequired",
  errorPinMisMatch: "errorPinMisMatch",
  errorPinDifferent: "errorPinDifferent",
  lblSureToDeleteAccount: "lblSureToDeleteAccount",
  lblDeleteAccount: "lblDeleteAccount",
  lblDelete: "lblDelete",
  msgFirstDeleteAccount: "msgFirstDeleteAccount",
  msgSecondDeleteAccount: "msgSecondDeleteAccount",
  lblDeleteAccountSuccess: "lblDeleteAccountSuccess",
  lblHi: "lblHi",
  lblReportIssue: "lblReportIssue",
  errorNoReportsFound: "errorNoReportsFound",
  lblReportCategory: "lblReportCategory",
  lblReportDescription: "lblReportDescription",
  lblChooseCategory: "lblChooseCategory",
  lblReportSubmitSuccess: "lblReportSubmitSuccess",
  errorReportSubmitFailure: "errorReportSubmitFailure",
  errorWriteSomeThing: "errorWriteSomeThing",
  lblGoBack: "lblGoBack",
  lblPauseThisConsent: "lblPauseThisConsent",
  lblReactivateThisConsent: "lblReactivateThisConsent",
  lblRejectThisConsent: "lblRejectThisConsent",
  lblRevokeThisConsent: "lblRevokeThisConsent",
  lblDeleteThisAccount: "lblDeleteThisAccount",
  msgSubTitlePauseConsent: "msgSubTitlePauseConsent",
  msgSubTitleReActivateConsent: "msgSubTitleReActivateConsent",
  msgSubTitleRejectConsent: "msgSubTitleRejectConsent",
  msgSubTitleRevokeConsent: "msgSubTitleRevokeConsent",
  lblNewMobileNumber: "lblNewMobileNumber",
  lblPersonalInformation: "lblPersonalInformation",
  lblAppearance: "lblAppearance",
  lblSecurity: "lblSecurity",
  lblAllTickets: "lblAllTickets",
  lblSolved: "lblSolved",
  lblUnAuthorized: "lblUnAuthorized",
  lblLinkAnotherAccount: "lblLinkAnotherAccount",
  lblOtpContinue: "lblOtpContinue",
  lblVerify: "lblVerify",
  lblEnterPinModel: "lblEnterPinModel",
  lblOtpSent: "lblOtpSent",
  lblOtpValidationRequest: "lblOtpValidationRequest",
  lblPinValidationRequest: "lblPinValidationRequest",
  lblContinueWithOtp: "lblContinueWithOtp",
  lblContinueWithPin: "lblContinueWithPin",
  lblStrongIdentifier: "lblStrongIdentifier",
  lblWeakIdentifier: "lblWeakIdentifier",
  lblCategoryType: "lblCategoryType",
  lblIdentifierType: "lblIdentifierType",
  lblIdentifierValue: "lblIdentifierValue",
  lblEnterIdentifierValue: "lblEnterIdentifierValue",
  errorEnterValidAadhaar: "errorEnterValidAadhaar",
  errorPanRequired: "errorPanRequired",
  errorEnterValidPan: "errorEnterValidPan",
  errorEnterValidEmail: "errorEnterValidEmail",
  errorEnterValidDOB: "errorEnterValidDOB",
  errorEnterValidAccountNumber: "errorEnterValidAccountNumber",
  lblConsentStart: "lblConsentStart",
  lblLogintxt: "lblLogintxt",
  lblsignUptxt: "lblsignUptxt",
  lblRbiTag: "lblRbiTag",

  lblOneConsentSmarterYou: "lblOneConsentSmarterYou",
  lblWelcomeBack: "lblWelcomeBack",
  lblToInk: "lblToInk",
  lblSecurelyAccessAccount: "lblSecurelyAccessAccount",
  lblManageFinancialData: "lblManageFinancialData",
  lblTrustedInstitutions: "lblTrustedInstitutions",
  lblYourData: "lblYourData",
  lblYourControl: "lblYourControl",
  lblSecure: "lblSecure",
  lblTransparency: "lblTransparency",
  lblAtEveryStep: "lblAtEveryStep",

  lblStartYour: "lblStartYour",
  lblInkJourney: "lblInkJourney",
  lblCreateYourAccountSecurely: "lblCreateYourAccountSecurely",
  lblShareManageFinancial: "lblShareManageFinancial",
  lblDataWithTrustedInstitutions: "lblDataWithTrustedInstitutions",

  lblSortByRecent: "lblSortByRecent",
  lblSortByOldest: "lblSortByOldest",
  lblActionRequired: "lblActionRequired",
  lblCurrentlyInUse: "lblCurrentlyInUse",
  lblExpiredRevokedOrClosed: "lblExpiredRevokedOrClosed",
  lblHome: "lblHome",
  lblSelectAccounts: "lblSelectAccounts",
  lblSelectAccountsDesc: "lblSelectAccountsDesc",
  lblAddAccount: "lblAddAccount",
  lblLinkedAccountsDesc: "lblLinkedAccountsDesc",
  lblType: "lblType",
  lblOperator: "lblOperator",
  lblValue: "lblValue",
  lblPendingYourAction: "lblPendingYourAction",
  lblReviewInformationAccess: "lblReviewInformationAccess",
  lblNeedHelp: "lblNeedHelp",
  lblContactOrganisation: "lblContactOrganisation",
  lblConsentWithdrawal: "lblConsentWithdrawal",
  lblViewWithdrawalProcess: "lblViewWithdrawalProcess",
  lblComplainToFIU: "lblComplainToFIU",
  lblViewComplaintProcess: "lblViewComplaintProcess",
  lblComplainToAA: "lblComplainToAA",
  lblComplainToDPB: "lblComplainToDPB",
  lblMoreInformationComingSoon: "lblMoreInformationComingSoon",


  lblManageLinkedAccounts: "lblManageLinkedAccounts",
  lblSearchInstitution: "lblSearchInstitution",
  lblAllTypes: "lblAllTypes",
  lblSavings: "lblSavings",
  lblCurrentAccount: "lblCurrentAccount",
  lblDeposit: "lblDeposit",
  lblInsurance: "lblInsurance",
  lblFindAndLinkAccounts: "lblFindAndLinkAccounts",
  lblViewAllFips: "lblViewAllFips",
  lblLinked: "lblLinked",
  lblLinkedAccountsCount: "lblLinkedAccountsCount",
  lblAccountActions: "lblAccountActions",
  lblLinkNewAccount: "lblLinkNewAccount",

  lblNoFipsFound: "lblNoFipsFound",
  lblEnterIdentifiers: "lblEnterIdentifiers",
  lblFindAccounts: "lblFindAccounts",
  lblReviewConsent: "lblReviewConsent",
  lblAccountLinked: "lblAccountLinked",
  lblBanking: "lblBanking",
  lblRbiRegisteredFip: "lblRbiRegisteredFip",
  lblSecureAndEncrypted: "lblSecureAndEncrypted",
  lblRbiRegulated: "lblRbiRegulated",
  lblYourDataIsSafe: "lblYourDataIsSafe",
  lblWeDoNotStoreData: "lblWeDoNotStoreData",
  lblAccountsFound: "lblAccountsFound",
  lblSelectAccountsToLink: "lblSelectAccountsToLink",
  lblAccount: "lblAccount",
  lblNoAccountsFoundYet: "lblNoAccountsFoundYet",
  lblEnterIdentifiersAndContinue: "lblEnterIdentifiersAndContinue",
  lblAll: "lblAll",
  lblBanks: "lblBanks",
  lblInvestments: "lblInvestments",
  lblGst: "lblGst",
  lblMutualFunds: "lblMutualFunds",
  lblPension: "lblPension",
  lblOthers: "lblOthers",
  lblProvideIdentifiers: "lblProvideIdentifiers",
  lblLinkAccountProgress: "lblLinkAccountProgress",
  lblAccountSelected: "lblAccountSelected",
  lblAccountsSelected: "lblAccountsSelected",
  lblIncompleteIdentifiers: "lblIncompleteIdentifiers",
  lblPleaseAddIdentifiers: "lblPleaseAddIdentifiers",
  msgOtpVerifiedSuccessfully: "msgOtpVerifiedSuccessfully",

  moreTermsDescription: "moreTermsDescription",
  moreProfileDescription: "moreProfileDescription",
  moreLinkAccountsDescription: "moreLinkAccountsDescription",
  moreResetPinDescription: "moreResetPinDescription",
  moreHistoryDescription: "moreHistoryDescription",
  moreLanguageDescription: "moreLanguageDescription",
  moreGrievanceDescription: "moreGrievanceDescription",
  moreReportDescription: "moreReportDescription",
  moreDeleteDescription: "moreDeleteDescription",
  morePrivacyDescription: "morePrivacyDescription",

  lblKeepDetailsUpdated: "lblKeepDetailsUpdated",
  lblYourInformationIsSecure: "lblYourInformationIsSecure",
  lblProfileIllustration: "lblProfileIllustration",
  lblYourProfile: "lblYourProfile",
  lblAccountDetailsNotificationPreferences: "lblAccountDetailsNotificationPreferences",
  lblPersonalInformationDescription: "lblPersonalInformationDescription",
  lblHideUserName: "lblHideUserName",
  lblShowUserName: "lblShowUserName",
  lblIdentifierCannotBeChanged: "lblIdentifierCannotBeChanged",
  lblHideMobileNumber: "lblHideMobileNumber",
  lblShowMobileNumber: "lblShowMobileNumber",
  lblRegisteredMobileCannotBeChanged: "lblRegisteredMobileCannotBeChanged",
  lblUnsavedChanges: "lblUnsavedChanges",
  lblAllChangesSaved: "lblAllChangesSaved",

  lblSetNewPinDescription: "lblSetNewPinDescription",
  lblSecurityIllustration: "lblSecurityIllustration",
  lblCreateNewPin: "lblCreateNewPin",
  lblPinSecurityDescription: "lblPinSecurityDescription",
  lblPinMustBeSixDigits: "lblPinMustBeSixDigits",

  lblDataProvidedToFinancialInstitution: "lblDataProvidedToFinancialInstitution",
  lblFinancialInstitution: "lblFinancialInstitution",
  lblNoActivitiesMatchFilters: "lblNoActivitiesMatchFilters",
  lblTransactionId: "lblTransactionId",
  lblViewConsentDataAccessActivity: "lblViewConsentDataAccessActivity",
  lblSearchHistoryPlaceholder: "lblSearchHistoryPlaceholder",
  lblAllStatus: "lblAllStatus",
  lblSuccess: "lblSuccess",
  lblExpired: "lblExpired",
  lblRejected: "lblRejected",
  lblRevoked: "lblRevoked",
  lblCompleted: "lblCompleted",
  lblEvent: "lblEvent",
  lblDetails: "lblDetails",
  lblStatus: "lblStatus",
  lblDateAndTime: "lblDateAndTime",
  lblBy: "lblBy",

  lblDeleteAccountPermanentWarning: "lblDeleteAccountPermanentWarning",
  lblAccountDeletionIllustration: "lblAccountDeletionIllustration",
  lblLinkedAccountsAndConsents: "lblLinkedAccountsAndConsents",
  lblLinkedAccountsAndConsentsDescription: "lblLinkedAccountsAndConsentsDescription",
  lblAccountHistory: "lblAccountHistory",
  lblAccountHistoryDescription: "lblAccountHistoryDescription",
  lblProfileInformation: "lblProfileInformation",
  lblProfileInformationDescription: "lblProfileInformationDescription",

  lblInkLogo: "lblInkLogo",
  lblLogoutIllustration: "lblLogoutIllustration",
  lblCompanyName: "lblCompanyName",
  lblRbiRegulatedAa: "lblRbiRegulatedAa",

  lblVuaIdInfo: "lblVuaIdInfo",
  lblOtpInstruction: "lblOtpInstruction",
  lblSecondsLeft: "lblSecondsLeft",
  lblResendOtp: "lblResendOtp",
  lblOtpInformationSecure: "lblOtpInformationSecure",

  lblLinkedDevices: "lblLinkedDevices",
  lblDevicesCurrentlyLinked: "lblDevicesCurrentlyLinked",
  lblMobileDevice: "lblMobileDevice",
  lblDeviceOptions: "lblDeviceOptions",
  lblRemoveDevice: "lblRemoveDevice",
  lblRemoveLinkedDevice: "lblRemoveLinkedDevice",
  lblConfirmRemoveLinkedDevice: "lblConfirmRemoveLinkedDevice",
  msgDeviceRemovedSuccessfully: "msgDeviceRemovedSuccessfully",

  lblPersonalizeNotifications: "lblPersonalizeNotifications",
  lblPersonalizeNotificationsDescription: "lblPersonalizeNotificationsDescription",
  lblNoDeviceLinked: "lblNoDeviceLinked",
  lblNoDeviceLinkedDescription: "lblNoDeviceLinkedDescription",
  lblNotAvailable: "lblNotAvailable", 

  lblNotificationPreferences: "lblNotificationPreferences",
  lblCustomizeNotificationPreferences: "lblCustomizeNotificationPreferences",
  lblChooseHowYouReceiveNotifications: "lblChooseHowYouReceiveNotifications",
  lblNotificationChannels: "lblNotificationChannels",
  lblChooseYourPreferredNotificationChannels: "lblChooseYourPreferredNotificationChannels",
  lblInAppNotifications: "lblInAppNotifications",
  lblReceiveNotificationsWithinApp: "lblReceiveNotificationsWithinApp",
  lblSmsNotifications: "lblSmsNotifications",
  lblReceiveNotificationsViaSms: "lblReceiveNotificationsViaSms",
  lblEmailNotifications: "lblEmailNotifications",
  lblReceiveNotificationsViaEmail: "lblReceiveNotificationsViaEmail",
  lblRealtimeNotifications: "lblRealtimeNotifications",
  lblChooseEventsYouWantToBeNotifiedAbout: "lblChooseEventsYouWantToBeNotifiedAbout",
  lblAccountLinking: "lblAccountLinking",
  lblNotifyWhenFinancialAccountLinked: "lblNotifyWhenFinancialAccountLinked",
  lblNotifyWhenConsentApproved: "lblNotifyWhenConsentApproved",
  lblConsentRevoked: "lblConsentRevoked",
  lblNotifyWhenConsentRevoked: "lblNotifyWhenConsentRevoked",
  lblConsentPausedResumed: "lblConsentPausedResumed",
  lblNotifyWhenConsentPausedResumed: "lblNotifyWhenConsentPausedResumed",
  lblSuccessfulDataFetch: "lblSuccessfulDataFetch",
  lblNotifyWhenDataSuccessfullyFetched: "lblNotifyWhenDataSuccessfullyFetched",
  lblScheduledSummaries: "lblScheduledSummaries",
  lblManageYourScheduledSummaryFrequency: "lblManageYourScheduledSummaryFrequency",
  lblMonthlyAaSummary: "lblMonthlyAaSummary",
  lblMandatory: "lblMandatory",
  lblActiveConsentDetailsAndDataFetchSummary: "lblActiveConsentDetailsAndDataFetchSummary",
  lblSentOnceAMonthViaEnabledChannels: "lblSentOnceAMonthViaEnabledChannels",
  lblFiuDataFetchSummary: "lblFiuDataFetchSummary",
  lblOptional: "lblOptional",
  lblChooseHowOftenDataFetchSummary: "lblChooseHowOftenDataFetchSummary",
  lblNotificationPreferencesInfo: "lblNotificationPreferencesInfo",
  lblUpdatePreferences: "lblUpdatePreferences",
  lblMonthly: "lblMonthly",
  lblFortnightly: "lblFortnightly",
  lblWeekly: "lblWeekly",
  lblDaily: "lblDaily",
  msgNotificationPreferencesUpdated: "msgNotificationPreferencesUpdated",
  
};
